/**
 * Terms entity class
 */

/**
 * TermsFactory
 * returns Terms entity class
 *
 * @class TermsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Terms} class
 *
 * @ngdoc factory
 * @name mwApp.factory:TermsFactory
 */
/* @ngInject */
export default function TermsFactory ($http, Entity, onOffMixin, m2mMixin) {
  /* === Terms class === */

  /**
   * Terms model
   *
   * @class Terms
   * @classdesc Terms model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.Terms} Terms entity
   */
  function Terms () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Terms.prototype = Object.create(Entity.prototype)
  Terms.prototype.constructor = Terms

  /* === Terms instance methods & fields === */

  Object.assign(Terms.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Terms#
     * @type {Object}
     */
    _fields: {
      termsAndConditionsId: Number,
      enabled: Boolean,
      message: String,
      networkId: Number,
      published: Boolean,
      subject: String,
      subscriptions: ['Subscription'],
      createdAt: String,
      updatedAt: String,
      createdBy: String,
      updatedBy: String
    },

    /**
     * url template
     *
     * @memberof models.Terms#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/terms-and-conditions/{{::termsAndConditionsId}}',

    /**
     * Prepare terms
     *
     * @memberof models.Terms#
     * @override
     */
    _prepare: function () {
      this.enabled = this.published // for onOffMixin
    },

    _isNew: function () {
      return !this.termsAndConditionsId
    }
  }, onOffMixin, m2mMixin('subscriptions'))

  /* === Terms static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Terms, Entity)
  Terms._name = 'Terms'
  Terms.init()

  Terms.getAvailableSubscriptions = function (networkId) {

  }

  // permissions
  // Terms.access = {}

  // extra
  // Terms.extra = {}

  return Terms
}
